import React, { Dispatch } from 'react';

import { ItemI } from 'views/Attendance/Attendance';

import TableCell from '../TableCell/TableCell';

const TableRow: React.FC<{
  student;
  subject;
  dates: string[];
  popoverOpened: string;
  attendances?: ItemI[];
  setPopoverOpened: Dispatch<React.SetStateAction<string>>;
  classTitle: string;
  subjectTitle: string;
  classId: string;
  semesterId: string;
  subjectId: string;
  refetchAttendances: () => void;
}> = ({
  student,
  subject,
  dates,
  attendances,
  popoverOpened,
  setPopoverOpened,
  classTitle,
  subjectTitle,
  classId,
  semesterId,
  subjectId,
  refetchAttendances,
}) => {
  return (
    <tr key={student.id + subject}>
      <td>{student.full_name}</td>
      {dates.map(date => {
        const attendance = attendances.find(item => {
          return (
            date === item.dateYMD &&
            item.subject_id === subject.teaching_structure_id &&
            student.id === item.student_id
          );
        });

        const id = `${date}_${student.id}`;
        return (
          <TableCell
            detailsOpened={id === popoverOpened}
            studentId={student.id}
            classTitle={classTitle}
            subjectTitle={subjectTitle}
            attendance={attendance}
            attendances={attendances}
            refetchAttendances={refetchAttendances}
            setPopoverOpened={setPopoverOpened}
            key={date}
            date={date}
            id={id}
            classId={classId}
            semesterId={semesterId}
            subjectId={subjectId}
          />
        );
      })}
    </tr>
  );
};

export default React.memo(TableRow);
